import React from 'react';
import { useCountdown } from './hooks/useCountdown';

const CountdownTimer = ({ targetDate }) => {
  const [days, hours, minutes, seconds] = useCountdown(targetDate);

  if (days + hours + minutes + seconds <= 0) {
    return (<h4 className="time danger">expired</h4>);
  } else {
    return (
      <h4 className={days===0 && hours===0 ? "time danger" : "time"}>
        {days}<span>d</span>
        &nbsp;{hours}<span>h</span>
        &nbsp;{minutes}<span>m</span>
        &nbsp;{seconds}<span>s</span>
      </h4>
    );
  }
  
};

export default CountdownTimer;